module.exports = __webpack_public_path__ + "static/media/package_develop_ios_app.c9cfe189.svg";